/**
 * вакансия
 *
 * @param {Object} params
 * @param {String} params.id айди вакансии
 * @param {String} params.contactsUrl URL для получения данных
 */
$.fn.vacancy = function(params) {
    var $self = $(this);
    var contactsUrl = params.contactsUrl;

    /**
     * Загрузить контакты
     */
    var loadContacts = function () {
        $.ajax({
            url: contactsUrl,
            method: 'get',
            dataType: 'json',
            success: function (result) {
                $self.find('.js-contacts-wrapper').empty().append([
                    $('<h2>Контакты</h2>'),
                    $('<ul><li>' + result.html + '</li></ul>')
                ]);
            },
            error: function () {
                console.error('Ошибка загрузки');
            }
        });
    };

    $self.on('click', '.js-show-contacts', function() {
        loadContacts();
        return false;
    });

    return this;
};


if ($('.js-vacancy').length > 0) {
    $('.js-vacancy').each(function() {
        $(this).vacancy({
            id: $(this).data('id'),
            contactsUrl: $(this).data('contacts-url'),
        });
    });

}
